import Markdown from "@/components/UI/Markdown/Markdown";
import clsx from "clsx";
import React, { FC } from "react";
import { CartBuilderResponseType } from "../CartTypes";
import styles from "./OrderHelp.module.scss";

interface OrderHelpProps {
	supportingInformation: CartBuilderResponseType["supportingInformation"];
}

export const OrderHelp: FC<OrderHelpProps> = ({ supportingInformation }) => {
	if (!supportingInformation) return null;
	return (
		<Markdown
			className={clsx(styles.orderHelp, "builder-text")}
			content={supportingInformation}
		/>
	);
};
